"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectPreviousAPICallAction = exports.selectPageToReturnTo = exports.selectIsInProgress = exports.selectHasError = exports.selectErrorMessage = exports.selectCurrentPage = void 0;
const selectHasError = instanceId => state => {
  return state.drools[instanceId].error.hasError;
};
exports.selectHasError = selectHasError;
const selectPreviousAPICallAction = instanceId => state => {
  return state.drools[instanceId].error.actionToRetry;
};
exports.selectPreviousAPICallAction = selectPreviousAPICallAction;
const selectIsInProgress = instanceId => state => {
  return state.drools[instanceId].error.retryIsInProgress;
};
exports.selectIsInProgress = selectIsInProgress;
const selectPageToReturnTo = instanceId => state => {
  return state.drools[instanceId].error.pageToReturnTo;
};
exports.selectPageToReturnTo = selectPageToReturnTo;
const selectCurrentPage = instanceId => state => {
  return state.drools[instanceId].error.pageToReturnTo || state.drools[instanceId].ui.currentPage;
};
exports.selectCurrentPage = selectCurrentPage;
const selectErrorMessage = instanceId => state => {
  return state.drools[instanceId].error.errorMessage;
};
exports.selectErrorMessage = selectErrorMessage;